var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar"},[_c('div',{staticClass:"tab-bar-border"}),_vm._l((_vm.tabbar.tabBarCustoms),function(item,index){return _c('div',{key:index,staticClass:"tab-bar-item"},[_c('div',{staticClass:"tab-bar-item-icon"},[_c('img',{attrs:{"src":_vm.png1}})]),_c('div',{style:({color: '#999999'})},[_vm._v(_vm._s(item.tabBarName))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }